import { saveUserCookieSettings } from "app/modules/analytics/analyticsHelpers";
import { UserCookieSettings } from "app/modules/analytics/analyticsTypes";
import { setUserCookieSettings } from "app/modules/analytics/redux/analyticsActions";

export const setUserCookieSettingsThunk = (cookieSettings: UserCookieSettings) => async (dispatch) => {
	dispatch(setUserCookieSettings(cookieSettings));
	saveUserCookieSettings(cookieSettings);
}